import React from 'react';
import { VIEW_COMPARISON } from '../data/Localization';

/**
 * Renders a button component for viewing comparisons.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {boolean} props.hidden - Determines if the button should be hidden.
 * @param {Function} props.onClick - The click event handler for the button.
 * @returns {JSX.Element} The rendered button component.
 */
const ViewCompareButton = (props) => {
	return (
		<calcite-button
			class={`prc__desc--compare_link ${props.hidden ? 'hidden' : ''}`}
			onClick={props.onClick}
			appearance="transparent"
			scale="s"
			round="">
			<span>{VIEW_COMPARISON}</span>
		</calcite-button>
	);
};

export default ViewCompareButton;
